import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Typography from '@segment/matcha/components/Typography';
export var Description = /*#__PURE__*/_styled(Typography, true ? {
  target: "euoz1230"
} : {
  target: "euoz1230",
  label: "Description"
})(true ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvRGF0YVZpc3VhbGl6YXRpb24vRGVzY3JpcHRpb24vRGVzY3JpcHRpb24udmlld3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTZDIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvRGF0YVZpc3VhbGl6YXRpb24vRGVzY3JpcHRpb24vRGVzY3JpcHRpb24udmlld3MudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IFR5cG9ncmFwaHkgZnJvbSAnQHNlZ21lbnQvbWF0Y2hhL2NvbXBvbmVudHMvVHlwb2dyYXBoeSdcblxuZXhwb3J0IGNvbnN0IERlc2NyaXB0aW9uID0gc3R5bGVkKFR5cG9ncmFwaHkpYFxuICBtYXJnaW46IDA7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});